<script lang="ts">
    import KpUserInfoCard from '../../../../../../features/user/KpUserInfoCard.svelte';
    import type {User} from 'typings/portaro.be.types';

    export let value: User;
    export let isSelected = false;

</script>

<template>
        <div class="panel panel-default" class:panel-primary={isSelected}>
            <div class="panel-body">
                <KpUserInfoCard user={value}/>
            </div>
        </div>
</template>